import { render, staticRenderFns } from "./UpdateEmail.vue?vue&type=template&id=c656c580&scoped=true&"
import script from "./UpdateEmail.vue?vue&type=script&lang=js&"
export * from "./UpdateEmail.vue?vue&type=script&lang=js&"
import style0 from "./UpdateEmail.vue?vue&type=style&index=0&id=c656c580&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c656c580",
  null
  
)

export default component.exports